<div id="productBottomSheet">
  <div class="share1" fxLayout="row" fxLayoutAlign="start center">
    <span>Share this product</span>
  </div>
  <div class="content pB-15" fxLayout="column" fxLayoutGap="20px">
    <div class="icon padding-2" matRipple fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
      <mat-icon>content_copy</mat-icon>
      <span>Copy Link</span>
    </div>
    <div class="icon  fab fa-whatsapp colorGreen padding-2" matRipple fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
      <!-- <mat-icon><i class="fab fa-whatsapp colorGreen"></i></mat-icon> -->
      <span>Whatsapp</span>
      <mat-icon  svgIcon="whatsapp" style="height: 100%;">
                        
      </mat-icon>
     
    </div>
    <div class="icon padding-2" matRipple fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
      <mat-icon><i class="fab fa-facebook-f color3b5"></i></mat-icon>
      <span>Facebook</span>
    </div>
    <div class="icon padding-2" matRipple fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
      <mat-icon><i class="fab fa-twitter color1da"></i></mat-icon>
      <span>Twitter</span>
    </div>

    <div class="icon padding-2" matRipple fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
      <mat-icon><i class="fas fa-at"></i></mat-icon>
      <span>Email</span>
    </div>
  </div>
  <mat-divider></mat-divider>
  <div (click)="close()" matRipple class="cancel" fxLayout="row" fxLayoutAlign="center center">
    <span class="click">Cancel</span>
  </div>
</div>